import React from "react";
import { motion } from "framer-motion";

const FadeWrapper = ({ children, direction = "none", duration = 1, distance = 20 }) => {
  let initial = {};
  switch (direction) {
    case "bottom":
      initial = { opacity: 0, translateY: distance };
      break;
    case "top":
      initial = { opacity: 0, translateY: -distance };
      break;
    case "left":
      initial = { opacity: 0, translateX: -distance };
      break;
    case "right":
      initial = { opacity: 0, translateX: distance };
      break;
    default:
      initial = { opacity: 0 };
  }

  return (
    <motion.div
      initial={initial}
      animate={{ opacity: 1, translateX: 0, translateY: 0 }}
      transition={{ duration }}
    >
      {children}
    </motion.div>
  );
};

export default FadeWrapper;
